import { TextField } from '@mui/material';
import { InitiativesStatusApi } from '../../../../pages/ActionPlan/hooks/useInitiativesStatus';
import { IColumn } from '../../Table';
import {
  StyledTableCell,
  StyledTableFooter,
  StyledTableFooterHead,
  StyledTableFooterTitle,
  StyledTableRow,
} from '../../Table.styles';
import { PLAN_TYPE } from '../../../../pages/ActionPlan/constants';
import { DueDatePicker } from '../../../../pages/ActionPlan/components/DueDatePicker';
import dayjs from 'dayjs';

type StatusProps = {
  initiativesStatusApi: InitiativesStatusApi;
  planTypeId: keyof typeof PLAN_TYPE;
};

const InitiativeStatusColumns: IColumn[] = [
  {
    id: 'status',
    name: 'Status Update',
    width: '4',
  },
  {
    id: 'date',
    name: 'Date',
    width: '2',
  },
] as const;

export const Status = ({ initiativesStatusApi, planTypeId }: StatusProps) => {
  const statusObject = initiativesStatusApi.getStatusObjectByPlanTypeId(PLAN_TYPE[planTypeId].id);

  return statusObject ? (
    <StyledTableFooter>
      <StyledTableFooterHead>
        {InitiativeStatusColumns?.map((col) => (
          <StyledTableCell key={col.id} colSpan={Number(col.width)}>
            <StyledTableFooterTitle>{col.name}</StyledTableFooterTitle>
          </StyledTableCell>
        ))}
      </StyledTableFooterHead>
      <StyledTableRow key={'status'}>
        {InitiativeStatusColumns.map((col) => {
          const field = col.id;

          switch (field) {
            case 'status':
              return (
                <StyledTableCell key={col.id} colSpan={Number(col.width)}>
                  <TextField
                    defaultValue={statusObject.statusUpdate ?? ''}
                    variant="standard"
                    fullWidth={true}
                    multiline
                    onBlur={(e) => {
                      initiativesStatusApi.updateStatusObjectFieldByPlanTypeId({
                        planTypeId: PLAN_TYPE[planTypeId].id,
                        field: 'statusUpdate',
                        value: e.target.value,
                      });
                    }}
                  />
                </StyledTableCell>
              );
            case 'date':
              return (
                <StyledTableCell key={col.id} colSpan={Number(col.width)}>
                  <DueDatePicker
                    date={
                      statusObject.statusUpdateDate ? dayjs(statusObject.statusUpdateDate) : dayjs()
                    }
                    setDate={(date) => {
                      initiativesStatusApi.updateStatusObjectFieldByPlanTypeId({
                        planTypeId: PLAN_TYPE[planTypeId].id,
                        field: 'statusUpdateDate',
                        value: date.format('YYYY-MM-DD'),
                      });
                    }}
                    disabled={false}
                  />
                </StyledTableCell>
              );
            default:
              return null;
          }
        })}
      </StyledTableRow>
    </StyledTableFooter>
  ) : null;
};
